<template>
  <transition name="modal">
    <div class="fixed inset-0 z-[1000] flex items-center justify-center overflow-auto bg-black/75 p-4">
      <div class="w-full max-w-[400px] overflow-hidden rounded-md bg-[#1e1e1e] text-slate-100 shadow-2xl">

        <div class="px-5 py-4 text-center">
          <slot></slot>
        </div>

        <div v-if="footerConfirm" class="flex items-center justify-end gap-3 border-t border-white/10 px-5 py-4">
          <div v-if="allowSkip" class="tb-checkbox mr-auto">
            <input
              type="checkbox"
              class="m-0 h-4 w-4"
              id="skipConfirmation"
              data-entity="producer-alert-skip"
              data-test="producer-alert-skip"
              @change="$emit('skipConfirmation')"
            >
            <label for="skipConfirmation">Don't show this again</label>
          </div>
          <tgb-button
            variant="tertiary"
            data-entity="producer-alert-cancel"
            data-test="producer-alert-cancel"
            @click="$emit('close')"
          >
            <span class="flex flex-col items-start gap-0.5">
              <span>{{ cancelLabel || "No, cancel." }}</span>
              <span v-if="cancelSubLabel" class="text-[10px] font-normal opacity-60">{{ cancelSubLabel }}</span>
            </span>
          </tgb-button>
          <tgb-button
            variant="primary"
            data-entity="producer-alert-confirm"
            data-test="producer-alert-confirm"
            @click="$emit('confirm')"
          >
            <span class="flex flex-col items-start gap-0.5">
              <span>{{ confirmLabel || "Yes, I'm sure." }}</span>
              <span v-if="confirmSubLabel" class="text-[10px] font-normal opacity-75">{{ confirmSubLabel }}</span>
            </span>
          </tgb-button>
        </div>

        <div v-if="footerClose" class="flex items-center justify-end gap-3 border-t border-white/10 px-5 py-4">
          <tgb-button
            variant="tertiary"
            data-entity="producer-alert-close"
            data-test="producer-alert-close"
            @click="$emit('close')"
          >
            Close
          </tgb-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import Button from '../button/Button.vue';

export default {
  props: ['footerConfirm', 'footerClose', 'allowSkip', 'skip', 'confirmLabel', 'cancelLabel', 'confirmSubLabel', 'cancelSubLabel'],
  components: {
    'tgb-button': Button,
  },
  created() {
    if (this.skip) {
      this.$emit('confirm');
    }
  },
};
</script>
